import { useNavigate } from 'react-router-dom'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import AddEmployeeModal from 'modules/timeoff/components/TimeoffPolicy/AddEmployee'
import AddEmployeeAssignmentModal from 'modules/timeoff/components/TimeoffPolicy/AddEmployeeAssignment'
import { hasPolicyTemporality } from 'modules/timeoff/lib/features/TimeoffFeatures'

const AddEmployeeModalPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { id } = useStrictParams<'id'>()

  const onClose = () => {
    navigate(navigation.settings.timeoffPolicies.id.employees.fullPath({ id }))
  }

  const { loading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  if (hasPolicyTemporality()) {
    return (
      <AddEmployeeAssignmentModal
        timeoffPolicyId={Number(id)}
        onClose={onClose}
        contractVersions={contractVersions}
        loading={loading}
      />
    )
  }

  return (
    <AddEmployeeModal
      timeoffPolicyId={Number(id)}
      onClose={onClose}
      contractVersions={contractVersions}
      loading={loading}
    />
  )
}

export default AddEmployeeModalPage
